import clsx from 'clsx'
import { useIntersectionObserver } from 'usehooks-ts'

import { FvLinkButton } from '@fv/client-components'

import { HideForVendor } from '../auth/HasRole'
import { useHasUnreadMessagesOnLoad } from '../messages/queries'

export type Props = {
  loadId: string
}
export const NewMessageIndicator = ({ loadId }: Props) => {
  const { isIntersecting, ref } = useIntersectionObserver()
  const hasUnreadMessages = useHasUnreadMessagesOnLoad({
    loadId,
    enabled: isIntersecting,
  })

  return (
    <HideForVendor>
      <div className="flex" ref={ref}>
        {hasUnreadMessages && <MessageLink />}
      </div>
    </HideForVendor>
  )
}

const MessageLink = () => (
  <FvLinkButton
    icon="comment-alt-dots"
    transform="down-1"
    iconClass="pulse-with-color"
    className={clsx('shipment-card__message-icon border-l border-fv-gray')}
    title="You have new messages"
  />
)
